"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenGraphSummary = exports.OpenGraphSummaryDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var image_element_1 = require("../elements/image-element");
exports.OpenGraphSummaryDefaultProps = {
  imageWidth: '35%',
  imageRounded: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: ", " 0 ", " 2px;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: ", " 0 ", " 2px;\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-weight: 500;\n    font-size: ", ";\n    color: ", ";\n    margin: 0 0 ", " 0;\n  "], ["\n    font-weight: 500;\n    font-size: ", ";\n    color: ", ";\n    margin: 0 0 ", " 0;\n  "])), theme_1.theme.FONT_SIZE(14), theme_1.theme.COLOR('text'), theme_1.theme.UNIT(2))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n    ", "\n    height: auto;\n  "], ["\n    ", "\n    ", "\n    height: auto;\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      width: ", ";\n    "], ["\n      width: ", ";\n    "])), props._width);
  }, function (props) {
    return props._rounded && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      border-radius: 100px;\n      border: 1px solid ", ";\n    "], ["\n      border-radius: 100px;\n      border: 1px solid ", ";\n    "])), theme_1.theme.COLOR('line-subtle'));
  })
});
var InfoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n    justify-content: center;\n    flex-direction: column;\n\n    ", "\n  "], ["\n    display: flex;\n    flex-grow: 1;\n    justify-content: center;\n    flex-direction: column;\n\n    ", "\n  "])), function (props) {
    return props.hasImage && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), theme_1.theme.UNIT(5));
  })
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", ";\n    color: ", ";\n    line-height: 1.5em;\n  "], ["\n    color: ", ";\n    font-size: ", ";\n    color: ", ";\n    line-height: 1.5em;\n  "])), theme_1.theme.COLOR('text-mid'), theme_1.theme.FONT_SIZE(14), theme_1.theme.FONT_SIZE(14))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: (0, styled_components_1.default)(image_element_1.ImageElement)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Info: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  Title: styled_components_1.default.h2(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Description: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
var OpenGraphSummary = function (props) {
  var className = props.className,
    entity = props.entity,
    imageWidth = props.imageWidth,
    imageRounded = props.imageRounded;
  var title = entity.title,
    image = entity.image,
    description = entity.description;
  var text = description && description.plainTruncated;
  return react_1.default.createElement(My.Container, {
    className: className
  }, image && react_1.default.createElement(My.Image, {
    _rounded: imageRounded,
    _width: imageWidth,
    entity: image
  }), react_1.default.createElement(My.Info, {
    hasImage: !!image
  }, react_1.default.createElement(My.Title, null, title), text && react_1.default.createElement(My.Description, null, text)));
};
exports.OpenGraphSummary = OpenGraphSummary;
exports.OpenGraphSummary.defaultProps = exports.OpenGraphSummaryDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;